import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateYourOwnUser } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import queryKeys from '@/queries/queryKeys';

export default function useMarkOnboardingCompleted() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      updateYourOwnUser(
        {
          body: {
            metadata: {
              outlookSidebarOnboardingCompletedAt: new Date(),
            },
          },
        },
        wgApi,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.me() });
    },
  });
}
